/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import VdiModel, { REMOTE_DESKTOP_TYPE } from './VdiModel';
import { IResourceProps } from 'apmui/resource/ResourceLoader';

class VmwareViewModel extends VdiModel {
    static readonly propNames = [...VdiModel.propNames];

    html5ClientUri?: string;
    nativeClientUri?: string;
    windowName?: string;

    rdType: REMOTE_DESKTOP_TYPE.VMWARE_VIEW;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);

        this.html5ClientUri = resource.props.html5ClientUri;
        this.nativeClientUri = resource.props.nativeClientUri;
        this.windowName = resource.props.windowName;
    }

    getPropNames() {
        return VmwareViewModel.propNames;
    }
}

export { VmwareViewModel as default, VmwareViewModel };
